import PropTypes from 'prop-types';

import { contentfulValuePropWithImageType } from 'types';
import Flex from 'legacy/components/flex';
import Box from 'legacy/components/box';
import Section from 'legacy/components/section';
import Heading from 'legacy/components/heading';
import ValuePropWithImage from 'legacy/components/valuePropWithImage';

const ValuePropWithImageSection = ({ heading, valueProps, ...props }) => (
  <Section {...props}>
    <Section.Inner>
      <Heading
        fontSize={[5, null, 40]}
        fontWeight={700}
        textAlign={['center', null, 'left']}
      >
        {heading}
      </Heading>
      <Flex flexWrap="wrap" justifyContent="space-between" mt={[4, null, 5]}>
        {valueProps.length === 2 && (
          <>
            {valueProps.map((valueProp) => (
              <Box key={valueProp.sys?.id} mt={[4, null, 0]} width={[1, null, 1 / 2]}>
                <ValuePropWithImage
                  image={valueProp.image}
                  heading={valueProp.heading}
                  content={valueProp.content}
                />
              </Box>
            ))}
          </>
        )}
        {valueProps.length === 3 && (
          <>
            {valueProps.map((valueProp) => (
              <Box
                key={valueProp.sys?.id}
                mt={[4, null, 0]}
                width={[1, null, 1 / 3]}
                px={[0, null, 3, 4]}
              >
                <ValuePropWithImage
                  image={valueProp.image}
                  heading={valueProp.heading}
                  content={valueProp.content}
                />
              </Box>
            ))}
          </>
        )}
      </Flex>
    </Section.Inner>
  </Section>
);

ValuePropWithImageSection.propTypes = {
  heading: PropTypes.string.isRequired,
  valueProps: PropTypes.arrayOf(contentfulValuePropWithImageType).isRequired,
};

export default ValuePropWithImageSection;
